module.exports = __webpack_public_path__ + "static/media/clock.2b8810e0.svg";